import { createRoute } from '@tanstack/react-router'
import { appShellRoute } from '@/app/routes/_appShell'
import { PoolsPage } from '@/features/pools/pages/PoolsPage'

/** ``/pools``: o canal ativo (como as outras telas) e ``new`` para abrir a criação. */
export interface PoolsSearch {
  channel?: string
  new?: boolean
}

export function validatePoolsSearch(raw: Record<string, unknown>): PoolsSearch {
  const out: PoolsSearch = {}
  if (typeof raw['channel'] === 'string' && raw['channel']) out.channel = raw['channel']
  if (raw['new'] === true || raw['new'] === 'true' || raw['new'] === 1) out.new = true
  return out
}

export const poolsRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/pools',
  validateSearch: validatePoolsSearch,
  component: PoolsListRoute,
})

export const poolDetailRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/pools/$slug',
  validateSearch: validatePoolsSearch,
  component: PoolDetailRoute,
})

function PoolsListRoute() {
  const search = poolsRoute.useSearch()
  return <PoolsPage selectedSlug={null} openCreate={search.new === true} />
}

function PoolDetailRoute() {
  const { slug } = poolDetailRoute.useParams()
  return <PoolsPage selectedSlug={slug} openCreate={false} />
}
